import classNames from 'classnames';
import React, { memo, useMemo } from 'react';

import { Typography } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import { IBlockProps } from './BigBlock';
import styles from './blocks.module.scss';

export const SmallBlock = memo<IBlockProps>(({ item, handleClick, darkTheme }) => {
  const isMobile = useIsMobile();

  const { key: type, pageUrl, picture, pictureForDarkTheme, title, text } = item;

  const pictureBlock = useMemo(() => {
    const inner = darkTheme && pictureForDarkTheme ? pictureForDarkTheme : picture;

    return (
      inner && (
        <div className={styles.pic}>
          <picture>{inner}</picture>
        </div>
      )
    );
  }, [darkTheme, picture, pictureForDarkTheme]);

  return (
    <div
      className={classNames(styles.block, styles[`block--small`], styles[`block--${type}`])}
      onClick={() => handleClick(pageUrl)}
    >
      {pictureBlock}
      <div className={styles.texts}>
        <div className={styles.header}>
          <Typography.Heading level={5} className={styles.title}>
            {title}
          </Typography.Heading>
        </div>
        <Typography.Text size={isMobile ? 12 : 14} className={'h-mt-8 h-color-D60'}>
          {text}
        </Typography.Text>
      </div>
    </div>
  );
});
